<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item>课程顾问跟进数据</Breadcrumb-item>
        <Breadcrumb-item>课顾汇总数据详情</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="search" @keyup.enter="search">
      <Form :label-width="60" :show-message="false">
        <Row :gutter="12">
          <Col :xs="12" :sm="16" :md="10" >
          </Col>
          <Col :xs="12" :sm="8" :md="5">
          <Form-item label="学生ID" >
            <Input name="uid"
                   v-model="queryParam.uid"></Input>
          </Form-item>
          </Col>
          <Col :xs="12" :sm="8" :md="5">
          <Form-item label="学生姓名" :label-width="75">
            <Input placeholder="支持模糊搜索" name="userNickname"
                   v-model="queryParam.nickName"></Input>
          </Form-item>
          </Col>
          <Col :xs="12" :sm="8" :md="5">
          <Form-item label="渠道" :label-width="75">
            <channel-select v-model="queryParam.regType" @on-change="search"></channel-select>
            <!-- <Select v-model.number="queryParam.regType" placeholder="全部"
                    clearable @on-change="search">
              <Option v-for="item in $constant.studentCanal"
                      :value="item.code" :key="item.code">{{ item.text }}</Option>
            </Select> -->
          </Form-item>
          </Col>
          <Col :xs="12" :sm="8" :md="4">
          <Button type="primary" :loading="searchLoading" :disable="searchLoading" icon="search"
                  @click="search" >搜索
          </Button>
          </Col>
        </Row>
      </Form>
    </div>
    <List ref="dataList" :tableColumns="title" :reload="reload" listUrl="/adminUser/getAdviserDataDetail"
          :params="queryParam" :onLoading="onLoading" operator=""></List>
  </div>
</template>
<script>

  export default {
    data () {
      return {
        searchLoading: false,
        exportLoading: false,
        reload: 0,
        queryParam: {
          adviserId: '',
          uid: '',
          nickName: '',
          startTime: '',
          endTime: '',
          cmd: '',
          regType: '',
        },
        assignNum: '',
        title: [
          {
            title: '学生ID',
            key: 'uid',
          },
          {
            title: '学生名字',
            key: 'nickName',
          },
          {
            title: '手机号',
            key: 'phoneNumber'
          },
          {
            title: '渠道',
            key: 'regType',
          },
        ]
      }
    },
    mounted: function () {
    },
    created: function () {
      this.queryParam.adviserId = localStorage.adviserId
      this.queryParam.startTime = localStorage.startTime
      this.queryParam.endTime = localStorage.endTime
      this.queryParam.cmd = localStorage.cmd
    },
    methods: {
      search () {
        this.reload = new Date().getTime()
      },
      onLoading (loading) {
        this.searchLoading = loading
      },
    }
  }
</script>



// WEBPACK FOOTER //
// ShowAdviserDataDetail.vue?6c6867f1